/** Section scoring participation — stored in ae_template_sections.scoring_config JSONB. */

export interface AeSectionScoringConfig {
  /** Default true when omitted — scored dimensions roll up into reports. */
  participates_in_scoring?: boolean;
}

/** True when section contributes to dimension list and score rollups. */
export function sectionParticipatesInScoring(
  scoring_config?: Record<string, unknown> | null
): boolean {
  const cfg = scoring_config as AeSectionScoringConfig | null | undefined;
  return cfg?.participates_in_scoring !== false;
}

export function scoringConfigForParticipation(participates: boolean): Record<string, unknown> {
  return { participates_in_scoring: participates };
}
